"use client";

import { useState } from "react";

export function useHasOpened(visible: boolean): boolean {
  const [hasOpened, setHasOpened] = useState(visible);

  if (visible && !hasOpened) {
    setHasOpened(true);
  }

  return hasOpened;
}
